import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactTab = ({ user, onUserUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    phone_number: '',
    alt_phone_number: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        phone_number: user.phone_number || '',
        alt_phone_number: user.alt_phone_number || ''
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API}/user/contact`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Kontaktdaten erfolgreich aktualisiert');
      
      // Update user data
      if (onUserUpdate) {
        onUserUpdate();
      }
    } catch (error) {
      console.error('Error updating contact:', error);
      toast.error(error.response?.data?.detail || 'Fehler beim Aktualisieren der Kontaktdaten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-1">Kontakt Informationen</h3>
        <p className="text-sm text-gray-500">Verwalten Sie Ihre Telefonnummern</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">E-Mail (schreibgeschützt)</Label>
          <Input
            id="email"
            value={user?.email || ''}
            disabled
            className="bg-gray-50 cursor-not-allowed"
          />
          <p className="text-xs text-gray-500">
            Die E-Mail-Adresse kann derzeit nicht geändert werden
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="phone_number">Telefonnummer</Label>
          <Input
            id="phone_number"
            name="phone_number"
            type="tel"
            value={formData.phone_number}
            onChange={handleChange}
            placeholder="+43 664 1234567"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="alt_phone_number">Alternative Telefonnummer (optional)</Label>
          <Input
            id="alt_phone_number"
            name="alt_phone_number"
            type="tel"
            value={formData.alt_phone_number}
            onChange={handleChange}
            placeholder="+43 1 234567"
          />
        </div>

        <div className="flex justify-center md:justify-end pt-4">
          <Button
            type="submit"
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 text-white w-full md:w-auto"
          >
            {loading ? 'Speichern...' : 'Telefonnummer speichern'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ContactTab;
